import { Component, OnDestroy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DataTypeComponent } from '../../../../../../../../components/data-type-widgets/data-type/data-type-component';
import { PlayersDetailsService } from '../../../../players-details.service';
import { PlayerRestrictionsDTO } from '../../../../player-details.model';

import { MatTooltip } from '@angular/material/tooltip';
import { PlayerJourneysRefreshService } from '../../../../player-journeys-refresh.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-player-applied-restrictions-tab',
  imports: [MatIcon, MatTooltip],
  templateUrl: './player-applied-restrictions-tab.component.html',
  styleUrl: './player-applied-restrictions-tab.component.scss',
})
export class PlayerAppliedRestrictionsTabComponent extends DataTypeComponent implements OnDestroy {
  playerId?: number;
  playerRestrictions: PlayerRestrictionsDTO | null = null;

  private readonly refreshEntitySubscription: Subscription;

  restrictionColumns = [
    { key: 'canDeposit', label: 'Can Deposit' },
    {
      key: 'canSpendMoney',
      label: 'Can Spend Money',
      hint: 'referring to real money only (without bonuses)',
    },
    {
      key: 'canPlay',
      label: 'Can Play',
      hint: 'referring to real money and bonuses',
    },
    { key: 'canWithdraw', label: 'Can Withdraw' },
    { key: 'allowMarketingComms', label: 'Allow Marketing Comms' },
    { key: 'canLogIn', label: 'Can Log In' },
  ];

  constructor(
    private readonly playerDetailsService: PlayersDetailsService,
    private readonly refreshService: PlayerJourneysRefreshService
  ) {
    super();

    this.refreshEntitySubscription = this.refreshService.refreshNeeded$.subscribe(() => {
      if (this.playerId !== undefined) {
        this.loadPlayerRestrictions();
      }
    });
  }

  override setRowData(entity: any): void {
    const playerId = entity.details?.playerId;

    if (playerId === undefined || playerId === null) {
      this.playerId = undefined;
      this.playerRestrictions = null;
      return;
    }

    this.playerId = playerId;
    this.loadPlayerRestrictions();
  }

  private loadPlayerRestrictions(): void {
    if (this.playerId === undefined) {
      return;
    }

    this.playerDetailsService.getPlayerRestrictions(this.playerId).subscribe((restrictions) => {
      this.setPlayerRestrictions(restrictions);
    });
  }

  private setPlayerRestrictions(restrictions: PlayerRestrictionsDTO | null): void {
    if (!restrictions || Object.keys(restrictions).length === 0) {
      this.playerRestrictions = null;
      return;
    }

    this.playerRestrictions = {
      ...restrictions,
      canSpendMoney: restrictions.canPlay ? restrictions.canSpendMoney : false,
    };
  }

  isRestrictionAllowed(key: string): boolean {
    const value: unknown = this.playerRestrictions?.[key];

    return value === true || value === 'true';
  }

  ngOnDestroy(): void {
    this.refreshEntitySubscription.unsubscribe();
  }
}
